import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";

export const startRegisterSearchResult = (trackingObject) => {
  
  return async (dispatch, getState) => {
    const state = getState();
    const { searchResultsRegisterEnabled } = state.configuration;

    if (searchResultsRegisterEnabled === "true") {
      
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEARCH_RESULT}`,
        "add",
        trackingObject,
        "POST"
      );

      const body = await resp.json();
      
      if (body.ok) {
        dispatch(registerSearchResult(body.searchResult));
      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } else {

    }
  };
};

const registerSearchResult = (searchResult) => ({
  type: types.SEARCH_RESULT_START_REGISTER,
  payload: searchResult,
});